import React, { Fragment } from 'react';
import {Col} from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';
import InputLabel from '../input/InputLabel';

class InputSearch extends AbstractComponent {    
    constructor(props) {
        super(props);

        this.state = {
            tooltip: false
        }
    }
        
    erro() {
        if(Array.isArray(this.props.erro)) {
            return(
                <ul>
                    {this.props.erro.map( (item , i) => {
                        return (
                            <li key={i}>{item}</li>
                        )
                    })}
                </ul>
            )
        }

        return this.props.erro;
    }    

    className() {
        return this.props.className !== undefined ? this.props.className : '';
    }    

    classNameInput() {
        return this.props.classNameInput !== undefined ? this.props.classNameInput : '';
    }
    
    classErro() {
        return this.props.erro !== undefined && this.props.erro !== '' ? 'form-controll-erro' : '';
    }    

    onChange(input) {        
        if (this.props.onChange !== undefined) {
          this.props.onChange(input);
        }
    }    

    onKeyPress(input) {        
        if (this.props.onKeyPress !== undefined) {
          this.props.onKeyPress(input);
        }
    }   

    onKeyUp(input) {
        var key = input.which || input.keyCode;

        if(key === 13) {
            if(this.props.onEnter !== undefined) 
                this.props.onEnter();            
        }
    }

    onBlur(input) {        
        if (this.props.onBlur !== undefined) {
          this.props.onBlur(input);
        }
    }
    
    componentDidMount() {        
        if(!this.props.defaultFoco)
            return ;
        
        this.foco(this.props.nome);
    }

    show() {
        if(!this.props.visible)
            return ;

        return (            
            <Col 
                md={this.props.md} 
                xs={this.props.xs} 
                sm={this.props.sm} 
                lg={this.props.lg}
                style={this.props.style}
            >
                <div 
                    className={this.props.mainClassName}
                    style={{
                        paddingLeft: '0px',
                        paddingRight: '0px'
                    }}
                >
                    <div className={this.className() + ' ' + this.classErro()} >
                        <label style={{float: 'left'}} htmlFor={this.props.nome}>
                            {this.props.children}

                            {
                                this.props.tooltip !== '' &&                                                                                
                                <button 
                                    type="button" 
                                    className={"btn btn-secondary my-tooltip " + (this.state.tooltip ? 'active' : '')}
                                    style={{
                                        
                                    }}                                
                                    onClick={() => this.setState({tooltip: !this.state.tooltip})}
                                    onBlur={() => this.setState({tooltip: false})} >
                                    <i className="fa fa-question-circle" aria-hidden="true"></i>

                                    <span className="my-tooltiptext">
                                        {this.props.tooltip}
                                    </span>
                                </button>                            
                            }
                        </label>                                       

                        <div className="input-group">
                            <input                             
                                autoComplete="off"                           
                                type={this.props.type} 
                                name={this.props.nome}                            
                                id={this.props.id}     
                                value={this.props.value}                        
                                defaultValue={this.props.defaultValue} 
                                className={"form-control search " + this.classNameInput()}
                                disabled={this.props.disabled} 
                                maxLength={this.props.maxLength}                           

                                onChange={input => this.onChange(input)}                            
                                onKeyPress={input => this.onKeyPress(input)}
                                onBlur={e => this.onBlur(e)}
                                onKeyUp={input => this.onKeyUp(input)}
                                readOnly={this.props.readOnly} 
                            />

                            <span className="input-group-append">
                                <button 
                                    className={"btn btn-primary " + (this.props.preload ? "is" : "not") + "-loading"}
                                    type="button"            
                                    disabled={this.props.disabled}                     
                                    onClick={() => this.props.onButtonClick()}
                                >
                                    <div className="btn-spinner">
                                        <div className="double-bounce1">
                                        </div>
                                        
                                        <div className="double-bounce2">
                                        </div>
                                    </div>

                                    <i className="fa fa-search"/>
                                </button>
                            </span>
                        </div>  

                        <span className="help-block">
                            {this.erro()}
                        </span>                  
                    </div>
                </div>

                <InputLabel
                    md={this.props.md2} 
                    xs={12} 
                    sm={this.props.md2} 
                    lg={this.props.md2}  
                    style={{paddingLeft: '0px', paddingRight: '0px'}}                  
                    value={this.props.result}
                />    
            </Col>                                                        
        )
    }

    render() {
        return (
            <Fragment>
                {this.show()}
            </Fragment>  
        )
    }
}

InputSearch.defaultProps = {
    md: 12,
    type: 'text',
    defaultFoco: false,
    visible: true,
    readOnly: false,
    tooltip: '',
    mainClassName: "col-md-2 col-sm-2 col-lg-2 col-xs-12",
    md2: 10
};

export default InputSearch;